exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "input[type=file][data-v-364b9550]{display:none}.step-03 .label[data-v-364b9550]{margin-bottom:.25rem;padding:.25rem;font-family:PT Sans Narrow,sans-serif;font-size:13px;text-transform:uppercase;letter-spacing:1px;display:block;color:#6f8695}.promotion-items-grid[data-v-364b9550]{grid-template-columns:2fr 3fr 1fr;border-bottom:1px solid #ccc;padding-bottom:.5rem;padding-top:.5rem}.alert[data-v-364b9550]{font-weight:400;padding:.5rem;letter-spacing:0;font-size:1rem}.rl-wizard[data-v-364b9550]{z-index:9999!important;position:relative}.rl-wizard--content--promotion[data-v-364b9550],.rl-wizard--content[data-v-364b9550]{height:550px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-364b9550","scoped":true,"hasInlineConfig":true}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/assets/js/components/person/residents/ResidentLedgerWizard.vue
// module id = nEe5
// module chunks = 0 1